export const objectEntriesTyped = (object) => Object.entries(object);
export const objectFromEntriesTyped = (entries) => Object.fromEntries(entries);
export const objectValuesTyped = (object) => Object.values(object);
export const objectKeysTyped = (object) => Object.keys(object);
